import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import email from "Assets/newicons/user-interface/mail/outline/mail-outline-16px.svg";
import mobile from "Assets/newicons/user-interface/mobile/outline/mobile-outline-16px.svg";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import ReactPhoneInput from "react-phone-input-2";
import Select from "react-select";
import phone from "Assets/newicons/services/phone-bill/outline/phone-bill-outline-16px.svg";
import { instance } from "../../../../Actions/AxiosInstance";
// import { ValidateAction } from "../../../../Utils/Validation";
import addressEmployee from "../../../../Assets/Images/contact.svg";
import behance from "../../../../Assets/Svg/bheance.svg";
import blog from "../../../../Assets/Svg/blogs.svg";
import conferenceId from "../../../../Assets/Svg/confrence.svg";
import dribbble from "../../../../Assets/Svg/dribble.svg";
import Facebook from "../../../../Assets/Svg/facebooklogo.svg";
import github from "../../../../Assets/Svg/github.svg";
import hangout from "../../../../Assets/Svg/hangout.svg";
import linkedIn from "../../../../Assets/Svg/linkdin.svg";
import pinterest from "../../../../Assets/Svg/pintrest.svg";
import quora from "../../../../Assets/Svg/quara.svg";
import skype from "../../../../Assets/Svg/skype.svg";
import slack from "../../../../Assets/Svg/slack.svg";
import { isValidEmailId } from "Utils"
import twitter from "../../../../Assets/Svg/twitter.svg";
import whatsapp from "../../../../Assets/Svg/watsapp.svg";
import If from "../../../../Component/Common/If";
import createstore from "../../../../store";
import CreateComp from "../create";
import { NoRecordFound } from "./NoRecordFound";

class EmpContact extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      helperText: {},
      country: [],
      AllAddress: [],
      flag: 0,
      addresstypeid: this.props.addresstypeid,
      inputType: "text",
      placeholder: "text",
      id: "Lbtext",
      defaultMessage: "Text",
      fields: {
        contacttypevalue: "",
      },
      reqFields: {
        contacttypevalue: "",
      },
      list: {
        contacttypeid: "",
        contacttagid: "",
      },
      reqList: {
        contacttypeid: "",
        contacttagid: "",
      },
      contacttypevalue: "",
      contactType: [],
      contactTag: [],
      ProfileBasicInfo: {},
      selectedContactType: {
        displayname: "Select Contact Type",
        displayvalue: "",
      },
      selectedContactTag: {
        displayname: "Select Contact Tag",
        displayvalue: "",
      },
      allContactList: [],
      isChange: false,
      successFlag: false,
      hideButton: false,
      dataReceived: false,
      masterprofileid:null,
    };
    this.GetProfileBasicInfo = this.GetProfileBasicInfo.bind(this);
    this.OnFieldChange = this.OnFieldChange.bind(this);
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");
    this.GetContactType();
    this.GetContactTag();

    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);

    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
        masterprofileid
      },
      () => {
        this.GetProfileBasicInfo();
        this.GetAllContactList();
      },
    );
  }

  SetFlag(value, addressid) {
    const flag = value;
    const addresstypeid = addressid;
    this.setState(
      { flag, addresstypeid, successFlag: false, contacttypevalue: "" },
      () => {
        if (this.firstElement) this.firstElement.focus();
      },
    );
  }

  GetProfileBasicInfo() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let ProfileBasicInfo = {};
        result.data.result.length != 0
          ? (ProfileBasicInfo = result.data.result[0])
          : (ProfileBasicInfo = {});
        this.setState({ ProfileBasicInfo });
        this.GetAllContactList();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetAllContactList() {
    const URL = "employee/getempallcontact";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        if (result.data.result.length == 0) {
          this.setState({ flag: 0, dataReceived: true });
        } else {
          this.setState({
            allContactList: result.data.result,
            dataReceived: true,
            flag: 2,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  OnCancel() {
    this.setState({
      list: {},
      fields: {},
      reqList: {},
      reqFields: {},
      contacttypeid: "",
      contacttagid: "",
      contacttypevalue: "",
      employeecontactid: "",
      selectedContactType: "",
      selectedContactTag: "",
      inputType: "",
      errors: {},
    });
  }

  BackLink() {
    this.OnCancel();
    this.state.allContactList.length == 0
      ? this.setState({ flag: 0 })
      : this.setState({ flag: 2 });
  }

  GetContactType() {
    instance
      .get("superuser/getmastercode/ContactType")
      .then((result) => {
        const contactType = [];
        contactType.push(
          { displayname: "Select Contact Type", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ contactType });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetContactTag() {
    instance
      .get("superuser/getmastercode/ContactTag")
      .then((result) => {
        const contactTag = [];
        contactTag.push(
          { displayname: "Select Contact Tag", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ contactTag });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularContact(contact) {
    this.GetInputType(contact.contacttypeid);
    const { fields } = this.state;
    const { list } = this.state;
    let contacttypevalue;

    if (
      this.state.selectedContactType.displayvalue == 6 ||
      this.state.selectedContactType.displayvalue == 3 ||
      this.state.selectedContactType.displayvalue == 17
    ) {
      fields.contacttypevalue = `+${contact.contacttypevalue}`;
      contacttypevalue = contact.contacttypevalue;
    } else {
      fields.contacttypevalue = contact.contacttypevalue;
      contacttypevalue = contact.contacttypevalue;
    }
    // fields['contacttypevalue'] = "+"+contact.contacttypevalue;
    list.contacttypeid = contact.contacttypeid;
    list.contacttagid = contact.contacttagid;
    const selectedContactType = this.state.contactType.find(
      (x) => x.displayvalue == contact.contacttypeid,
    );
    const selectedContactTag = this.state.contactTag.find(
      (x) => x.displayvalue == contact.contacttagid,
    );
    const { employeecontactid } = contact;
    this.setState(
      {
        flag: 1,
        fields,
        list,
        selectedContactType,
        selectedContactTag,
        employeecontactid,
        contacttypevalue,
      },
      () => {
        if (this.firstElement) this.firstElement.focus();
      },
    );
  }

  Validate() {
    let isValid = true;
    const { errors } = this.state;

    if (!this.state.list.contacttypeid) {
      errors.contacttypeid = true;
      this.setState({ CommonError: "Please Select Contact Type", errors });
      return (isValid = false);
    }
    errors.contacttypeid = false;
    this.setState({ CommonError: "", errors });

    if (!this.state.list.contacttagid) {
      errors.contacttagid = true;
      this.setState({ CommonError: "Please Select Contact Tag", errors });
      return (isValid = false);
    }
    errors.contacttagid = false;
    this.setState({ CommonError: "", errors });

    if (!this.state.contacttypevalue) {
      errors.contacttypevalue = true;
      this.setState({ CommonError: "Please Enter valid Details", errors });
      return (isValid = false);
    }
    errors.contacttypevalue = false;
    this.setState({ CommonError: "", errors });

    const str = this.state.contacttypevalue.trim();
    if (str.length < 12) {
      errors.contacttypevalue = true;
      this.setState({ CommonError: "Please Enter valid Details", errors });
      return (isValid = false);
    }

    return isValid;
  }

  UpdateContact() {
    if (!this.Validate()) {
      setTimeout(
        () =>
          this.props.enqueueSnackbar(this.state.CommonError, {
            variant: "error",
          }),
        300,
      );
      // this.props.enqueueSnackbar("Please fill all the required fields", { variant: 'error' })
    } else if(this.state.list.contacttypeid == 1 && this.state.contacttypevalue && !isValidEmailId(this.state.contacttypevalue) ){
     
      this.props.enqueueSnackbar("Please enter valid email id", { variant: 'error' })

    } else {
      const data = {
        employeecontactid: this.state.employeecontactid,
        contacttypeid: this.state.list.contacttypeid,
        contacttagid: this.state.list.contacttagid,
        contacttypevalue: this.state.contacttypevalue,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
          employeeid: this.props.colleagueid || this.state.employeeid,
        });
      }
      this.setState({ data });
      instance
        .post("employee/insertUpdateempcontact", data)
        .then(() => {
          this.setState({
            employeecontactid: "",
            fields: {},
            list: {},
            flag: 2,
            successFlag: true,
            selectedContactType: {
              displayname: "Select Contact Type",
              displayvalue: "",
            },
            selectedContactTag: {
              displayname: "Select Contact Tag",
              displayvalue: "",
            },
          });
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.GetAllContactList();
          this.props.UpdateStrength(true);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  UpdateContactTagId(name, HtField, selectedItem) {
    const { list } = this.state;
    const { errors } = this.state;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    // reqList[name] = selectedItem.displayvalue ? selectedItem.displayvalue : '';
    !selectedItem.displayvalue ? (errors[name] = true) : (errors[name] = false);
    const selectedContactTag = selectedItem;
    this.setState({ list, errors, selectedContactTag });
  }

  GetInputType(value) {
    let inputType;

    if (value == 1) {
      inputType = "email";
    } else if (value == 2 || value == 17) {
      inputType = "mobile";
    } else if (value == 3) {
      inputType = "phone";
    } else if (value == 4 || value == 5 || value == 6 || value == 7) {
      inputType = "id";
    } else if (
      value == 8 ||
      value == 9 ||
      value == 10 ||
      value == 13 ||
      value == 14 ||
      value == 15 ||
      value == 16
    ) {
      inputType = "url";
    } else {
      inputType = "text";
    }

    this.setState({ inputType });
  }

  UpdateContactTypeId(name, HtField, selectedItem) {
    const { list } = this.state;
    const { errors } = this.state;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    // reqList[name] = selectedItem.displayvalue ? selectedItem.displayvalue : '';
    const selectedContactType = selectedItem;
    this.GetInputType(selectedItem.displayvalue);
    const { fields } = this.state;
    const { reqFields } = this.state;
    fields.contacttypevalue = "";
    reqFields.contacttypevalue = "";
    !selectedItem.displayvalue ? (errors[name] = true) : (errors[name] = false);
    this.setState({
      list,
      errors,
      reqFields,
      contacttypevalue: "",
      selectedContactType,
      fields,
    });
  }

  OnPhoneChange(field, value) {
    const { fields } = this.state;
    fields.contacttypevalue = "";
    fields.countryname = value.name;
    fields.callingcode = value.dialCode;
    fields.mobilenumber = field;
    field = field.replace(/[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g, "");
    // fields["contacttypevalue"] = no.trim();
    fields.contacttypevalue = field.trim();
    const contacttypevalue = field.trim();
    this.setState({ fields, contacttypevalue });
  }

  OnFieldChange = (key, value) => {
    const { fields } = this.state;
    fields[key] = value;
    console.log("fields: ", fields);
    this.setState({ fields });
  };

  DeleteContact = (item) => {
    const employeeid = this.props.colleagueid || this.state.employeeid;
    const data = {
      employeeid : employeeid,
    }
    const URL = `employee/deleteempcontact/${item.employeecontactid}`;
    instance
      .delete(URL, this.state.masterprofileid && this.state.masterprofileid == 9 && {data})
      .then(() => {
        this.props.enqueueSnackbar("deleted successfully", {
          variant: "success",
        });
        this.GetAllContactList();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  Deleteconfirmation = (item) => {
   
    this.props.enqueueSnackbar(`Are you sure you want to delete?`, {
      variant: "warning",
      action: [
        <Button
          variant="outlined"
          color="inherit"
          className="margin-right-16"
          size="small"
          onClick={() => {this.DeleteContact(item);  this.props.closeSnackbar();}}
        >
          Delete
        </Button>,
        <Button color="inherit" size="small" onClick={() => this.props.closeSnackbar()} >
          Cancel
        </Button>,
      ],
    });
  };

  _renderCreateComp = () => {
    const { hideButton } = this.state;

    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            {!hideButton ? (
              <CreateComp
                text="What are different ways to contact you"
                heading="Contact details"
                onCreate={this.SetFlag.bind(this, 1, 1)}
                imageSrc={addressEmployee}
              />
            ) : (
              <NoRecordFound />
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  _renderListComp = () => {
    const { classes } = this.props;
    const { hideButton } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div className="emp-profile-tab-height">
              {this.state.successFlag ? (
                <p className="input-form-label address-label">
                  {" "}
                  <FormattedMessage
                    id="Lbcontactreceived"
                    defaultMessage="Congratulations, you have added your contact details successfully."
                  />
                </p>
              ) : (
                ""
              )}

              {this.state.allContactList.length > 0 ? (
                <div className="profile-data-view-page">
                  <div className="width100">
                    {this.state.allContactList.map((contact) => (
                      <div className="padding-bottom-20 position-rel">
                        <p className="address-data contact-emp display-flex">
                          {contact.contacttypeid == 1 ? (
                            <span>
                              <img src={email} alt="icon" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 2 ? (
                            <span>
                              <img src={mobile} alt="icon" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 3 ? (
                            <span>
                              <img src={phone} alt="icon" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 4 ? (
                            <span>
                              <img src={skype} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 5 ? (
                            <span>
                              <img src={hangout} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 6 ? (
                            <span>
                              <img src={slack} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 7 ? (
                            <span>
                              <img src={conferenceId} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 8 ? (
                            <span>
                              <img src={Facebook} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 9 ? (
                            <span>
                              <img src={twitter} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 10 ? (
                            <span>
                              <img src={linkedIn} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 11 ? (
                            <span>
                              <img src={behance} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 12 ? (
                            <span>
                              <img src={dribbble} alt="icon" height="16" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 13 ? (
                            <span>
                              <img src={pinterest} alt="icon" height="20" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 14 ? (
                            <span>
                              <img src={github} alt="icon" height="20" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 15 ? (
                            <span>
                              <img src={quora} alt="icon" height="20" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 16 ? (
                            <span>
                              <img src={blog} alt="icon" height="20" />
                            </span>
                          ) : (
                            ""
                          )}
                          {contact.contacttypeid == 17 ? (
                            <span>
                              <img src={whatsapp} alt="icon" height="20" />
                            </span>
                          ) : (
                            ""
                          )}

                          <span className="margin-left-16 small-dark">
                            {contact.contacttypevalue}
                            <br />
                            <Chip
                              label={contact.contacttagname}
                              className={classes.chip}
                              style={{ height: 24 }}
                            />
                          </span>
                        </p>

                        <If condition={!hideButton}>
                          <div>
                            <svg
                              className={"address-edit cursour-pointer"}
                              onClick={this.GetPerticularContact.bind(
                                this,
                                contact,
                              )}
                              width="24"
                              style={{ marginRight: 40 }}
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                            </svg>
                            <svg
                              className={"address-edit cursour-pointer"}
                              onClick={() => this.Deleteconfirmation(contact)}
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                              <path fill="none" d="M0 0h24v24H0V0z" />
                            </svg>
                          </div>
                        </If>
                      </div>
                    ))}
                  </div>
                  {!hideButton && (
                    <div
                      className="add-more-button margin-bottom-40"
                      onClick={this.SetFlag.bind(this, 1, null)}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        className="no-shadow"
                      >
                        Add More
                      </Button>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <FormattedMessage
                    id="LbNoRecordFound"
                    defaultMessage=" No Record Found"
                  />
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  _renderEditComp = () => {
    const { list, fields, contacttypevalue } = this.state;
    return (
      <div className="emp-profile-tab-height">
        <div className="emp-from-wrapper imp-dates">
          <form>
            <div className="form-group">
              <p className="input-form-label">
                <FormattedMessage
                  id="LbContactType"
                  defaultMessage="Contact Type"
                />{" "}
              </p>
              <Select
                ref={(r) => {
                  this.firstElement = r;
                }}
                className="selectsearch ContactType1"
                onChange={this.UpdateContactTypeId.bind(
                  this,
                  "contacttypeid",
                  "HtContactType",
                )}
                options={this.state.contactType}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedContactType}
                placeholder="Contact Type"
              />
              <div>
                {this.state.errors.contacttypeid ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="ErContactType"
                      defaultMessage="please select Contact Type"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="form-group">
              <p className="input-form-label">
                {" "}
                <FormattedMessage
                  id="LbContactTag"
                  defaultMessage="Contact Tag"
                />{" "}
              </p>
              <Select
                className="selectsearch ContactTag1"
                onChange={this.UpdateContactTagId.bind(
                  this,
                  "contacttagid",
                  "HtContactTag",
                )}
                options={this.state.contactTag}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedContactTag}
                placeholder="Contact Tag"
              />
              <div>
                {this.state.errors.contacttagid ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="ErContactTag"
                      defaultMessage="please select Contact Tag"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="form-group contact-phone">
              <p className="input-form-label">
                {" "}
                <FormattedMessage
                  id="LbEnterdetails"
                  defaultMessage="Enter Details"
                />{" "}
              </p>

              {(list.contacttypeid == 2 || list.contacttypeid == 17) && (
                <ReactPhoneInput
                  defaultCountry={"in"}
                  countryCodeEditable={true}
                  className="form-control"
                  onChange={this.OnPhoneChange.bind(this)}
                  // onBlur={this.ValidateField.bind(this, "contacttypevalue", "mobile")}
                  // value={this.state.fields.contacttypevalue}
                  value={contacttypevalue}
                  InputProps={{ maxLength: 15, minLength: 5 }}
                />
              )}
              {!(list.contacttypeid == 2 || list.contacttypeid == 17) && (
                <TextField
                  className="contacttypevalue phone"
                  id="outlined-dense"
                  margin="dense"
                  variant="outlined"
                  value={contacttypevalue}
                  // value={fields.contacttypevalue}
                  maxLength="40"
                  onChange={(e) =>
                    this.setState({ contacttypevalue: e.target.value })
                  }
                  // onChange={(e) => this.OnFieldChange("contacttypevalue", e.target.value)}
                />
              )}

              <div>
                {this.state.errors.contacttypevalue ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="Ercontacttypevalue"
                      defaultMessage="please enter valid details"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div>
              <div className="inlineClass">
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  className="form-btn save"
                  onClick={this.UpdateContact.bind(this)}
                >
                  <FormattedMessage id="BtSave" defaultMessage="Save" />
                </Button>
              </div>
              <div className="inlineClass margin-left-16">
                <Button
                  size="large"
                  onClick={this.BackLink.bind(this)}
                  className="Cancel"
                >
                  <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

  render() {
    const { dataReceived } = this.state;
    const { flag } = this.state;

    return (
      <If condition={dataReceived}>
        <div>
          <If condition={flag == 0}>{this._renderCreateComp()}</If>
          <If condition={flag == 1}>{this._renderEditComp()}</If>
          <If condition={flag == 2}>{this._renderListComp()}</If>
        </div>
      </If>
    );
  }
}

export default withSnackbar(EmpContact);
